import { Image } from '@react-pdf/renderer';
import React from 'react';
import { Box, Flex, Title } from '../../pdf-design-system';
import banner from './images/MaximeHerkunftBottleshowLogo.jpeg';

export default function MaximeHerkunftTableSignHeader({ style }) {
  return (
    <Flex style={[{ alignItems: 'center', justifyContent: 'center' }, style]}>
      <Image src={banner} style={{ width: '12cm' }} />
    </Flex>
  );
}
